// Which Mitigation Group "owns" a hex belonging to several. Lower displayPriority wins. The server
// assigns priorities densely, so the id leg only matters if two groups ever share one — it keeps hex
// ownership deterministic rather than falling back to arbitrary response order.
export function compareGroupPrecedence (a, b) {
  const priority = (a?.displayPriority ?? Number.MAX_SAFE_INTEGER) - (b?.displayPriority ?? Number.MAX_SAFE_INTEGER)
  return priority !== 0 ? priority : (a?.mitigationGroupId ?? 0) - (b?.mitigationGroupId ?? 0)
}

// Wire rows flatten the group's precedence fields under their own names.
const groupRowShape = row => ({
  displayPriority: row?.displayPriority,
  mitigationGroupId: row?.mitigationGroupId
})

export function compareGroupRowPrecedence (a, b) {
  return compareGroupPrecedence(groupRowShape(a), groupRowShape(b))
}

export function matchedGroupsByPrecedence (entries, groupsById) {
  if (!groupsById?.size) return []
  const matched = new Map()
  ;(entries ?? []).forEach(entry => {
    const group = groupsById.get(entry?.id)
    if (group) matched.set(group.mitigationGroupId, group)
  })
  return Array.from(matched.values()).sort(compareGroupPrecedence)
}

export function highestPriorityGroup (entries, groupsById) {
  return matchedGroupsByPrecedence(entries, groupsById)[0] ?? null
}
